// import Push from "push.js"
import { catchError, Observable, of, tap } from 'rxjs'
import { Injectable, inject } from "@angular/core";
import { LocalRepository } from "@shared/helper/local-repository";
import { FirebaseClientToken, NotificationModel } from "@app/pages/notifications/models/notification-model";
import { NotificationsService } from '@app/pages/notifications/services/notifications.service';
import { FirebaseNotificationGeneratorService } from "../notificationFactory/firebase-notification-generator.service";
import { getToken, MessagePayload, Messaging, onMessage } from "@angular/fire/messaging";
import { pascalToCamel } from "@shared/utils/pascal-to-camel";

@Injectable({
  providedIn: 'root'
})
export class FCMService {
  private notificationsService = inject(NotificationsService);
  private repo = inject(LocalRepository);
  private notificationService = inject(FirebaseNotificationGeneratorService);
  private messaging = inject(Messaging);


  private message$!: Observable<MessagePayload>;
  clientToken!: FirebaseClientToken;

  constructor() {
    if (this.repo.IsInBrowser) {
      this.requestPermission().then(stream => stream.subscribe());

      // ? defining FCM message observable
      this.message$ = new Observable(observer =>
        onMessage(this.messaging, (msg) => observer.next(msg))
      );
    }

  }


  listenToFcmMessages() {
    return this.message$.pipe(
      tap(msg => this.popUpMessage(msg.data)),
      // tap(msg => { console.log('msg', msg) }),
    );
  }

  async requestPermission(): Promise<Observable<any>> {

    if (!this.IsNotificationsSupported)
      return of(null);

    const permission = await Notification.requestPermission();

    console.log('permission', permission);


    if (permission === 'denied') {
      // console.log('denied!');
      return of(null);
    }

    else {
      // console.log('granted!');
      const token = await getToken(this.messaging);
      // console.log('token', token);

      return token ? this.addClientToken(token) : of(null);
    }

  }


  popUpMessage(data: any) {
    const payload: NotificationModel = pascalToCamel(JSON.parse(data['payload']));
    const receiver: string = data['receiver'];
    // console.log('payload', payload);

    const siteUrl = self.location.href.replace('http://', 'https://');


    let imageUrl = "https://s3.ir-thr-at1.arvanstorage.com/stage-topreader-net";
    if (siteUrl == 'https://behkhaan.ir') {
      imageUrl = 'https://s3.ir-thr-at1.arvanstorage.com/top-readers-publishers';
    }

    const notificationData = this.notificationService.generateNotification(
      payload,
      receiver,
      imageUrl,
      siteUrl
    );

    // console.log('notificationData', notificationData);


    const w = this.repo.getWindow;


    const notif = new Notification('بهخوان', {
      body: notificationData.message,
      icon: notificationData.iconUrl,
    });

    notif.onclick = () =>  w?.open(notificationData.onClickUrl)

    // Push.create('بهخوان', {
    //   body: notificationData.message,
    //   icon: notificationData.iconUrl,
    //   timeout: 4000,
    //   onClick() {
    //     w?.open(notificationData.onClickUrl);
    //   }
    // });

  }

  public get IsNotificationsSupported(): boolean {
    if (('Notification' in window) && ('serviceWorker' in navigator)) {
      return true;
    }
    console.warn('Push notifications are not supported in this browser.');
    return false;
  }

  addClientToken(token: string) {
    // console.log('in addClientToken');
    this.clientToken = { Type: 'web', Token: token };
    return this.notificationsService.addClientToken(this.clientToken).pipe(
      catchError(err => {
        console.log(err);
        return of(null);
      })
    );
  }




}
